import { render, staticRenderFns } from "./ShareRedPackets.vue?vue&type=template&id=5f007aaa&"
import script from "./ShareRedPackets.vue?vue&type=script&lang=js&"
export * from "./ShareRedPackets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports